import React from 'react';
import { SEO, SEOConfig } from './SEO';
import { MainFooter } from './Footer';
import { Header } from './Header';

export const ImpressumPage = () => {
  return (
    <>
      <SEO {...SEOConfig.impressum} />
      <div className="min-h-screen bg-white">
        <Header />

        {/* Main Content */}
        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
          {/* Page Header */}
          <div className="text-center mb-32">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Impressum
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-teal-700 to-blue-500 mx-auto mb-6"></div>
            <p className="text-lg text-gray-700">
              Angaben gemäß § 5 TMG
            </p>
          </div>

          {/* Content */}
          <div>
            <div className="prose prose-lg max-w-none">

                {/* Company Info */}
                <section className="mb-12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Angaben zum Unternehmen
                  </h2>
                  <div className="text-gray-700 leading-normal">
                    <p className="text-xl text-gray-900">
                      EnBet-Consulting UG (haftungsbeschränkt)<br />
                      Im Tal 30<br />
                      34270 Schauenburg<br />
                      Deutschland
                    </p>
                  <p className="text-xl text-gray-900">
                      Umsatzsteuer-Identifikationsnummer: DE346037206
                    </p>
                  </div>
                </section>

                {/* Contact */}
                <section className="mb-12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Kontakt
                  </h2>
                  <div className="space-y-2 text-gray-700 leading-relaxed">
                    <p>
                      <span className="font-medium text-gray-900">Geschäftsführer:</span> Sebastian Funke
                    </p>
                    <p>
                      <span className="font-medium text-gray-900">E-Mail-Adresse:</span>{' '}
                      <a href="mailto:info@idaki.de" className="text-teal-700 hover:text-teal-800 transition-colors">
                        info@idaki.de
                      </a>
                    </p>
                    <p>
                      <span className="font-medium text-gray-900">Telefon:</span>{' '}
                      <a href="tel:+4917623943896" className="text-teal-700 hover:text-teal-800 transition-colors">
                        +49 (0) 176 23 94 38 96
                      </a>
                    </p>
                  </div>
                </section>

                {/* Legal Notices */}
                <section className="mb-12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Rechtliche Hinweise
                  </h2>

                  <div className="space-y-8">
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-3">Haftung für Inhalte</h3>
                      <p className="text-gray-700 leading-relaxed">
                        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
                        Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
                        nach den allgemeinen Gesetzen verantwortlich.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-3">Haftung für Links</h3>
                      <p className="text-gray-700 leading-relaxed">
                        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir
                        keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
                        Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
                        Anbieter oder Betreiber der Seiten verantwortlich.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-3">Urheberrecht</h3>
                      <p className="text-gray-700 leading-relaxed">
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
                        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung
                        und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                        schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                      </p>
                    </div>
                  </div>
                </section>

                {/* B2B Notice */}
                <div className="bg-gray-50 border-l-4 border-teal-700 p-6 mb-12">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Hinweis zur Geschäftstätigkeit</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Unser Angebot richtet sich ausschließlich an <strong>Unternehmer</strong> im Sinne
                    des § 14 BGB. Verbraucher (§ 13 BGB) sind von der Nutzung ausgeschlossen.
                  </p>
                </div>

                {/* Barrierefreiheit */}
                <section className="mb-12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Barrierefreiheit
                  </h2>
                  <div className="space-y-4 text-gray-700 leading-relaxed">
                    <p>
                      Wir sind bestrebt, unsere Website im Einklang mit dem <strong>Barrierefreiheitsstärkungsgesetz (BFSG)</strong>
                      und der <strong>EN 301 549</strong> möglichst barrierefrei zu gestalten. Unsere Website orientiert sich
                      an den <strong>Web Content Accessibility Guidelines (WCAG) 2.1 Level AA</strong>.
                    </p>
                    <p className="font-medium text-gray-900">
                      Bereits umgesetzte Maßnahmen:
                    </p>
                    <ul className="list-disc list-inside ml-4 space-y-2">
                      <li>Semantische HTML-Struktur</li>
                      <li>Aussagekräftige Alt-Texte für Bilder</li>
                      <li>ARIA-Labels für interaktive Elemente</li>
                      <li>Keyboard-Navigation möglich</li>
                      <li>Ausreichende Farbkontraste</li>
                      <li>Responsive Design für verschiedene Bildschirmgrößen</li>
                    </ul>
                    <p>
                      Sollten Sie Barrieren auf unserer Website feststellen oder Unterstützung benötigen,
                      kontaktieren Sie uns bitte:
                    </p>
                    <div className="bg-gray-50 border border-gray-200 p-4 space-y-1">
                      <p>
                        <strong>E-Mail:</strong>{' '}
                        <a href="mailto:info@idaki.de" className="text-teal-700 hover:text-teal-800 transition-colors">
                          info@idaki.de
                        </a>
                      </p>
                      <p>
                        <strong>Telefon:</strong>{' '}
                        <a href="tel:+4917623943896" className="text-teal-700 hover:text-teal-800 transition-colors">
                          +49 (0) 176 23 94 38 96
                        </a>
                      </p>
                    </div>
                    <p className="text-sm text-gray-600">
                      Wir arbeiten kontinuierlich an der Verbesserung der Barrierefreiheit unserer digitalen Angebote.
                    </p>
                  </div>
                </section>

            </div>
          </div>
        </main>

        <MainFooter />
      </div>
    </>
  );
};

export default ImpressumPage;
